import pattern_conflictZone from '@assets/pattern-conflictZone-512x-or.png';
import {
  useActivationAndFlightPlanByActivationId,
  useFlightPlansManagementContext,
} from '@components/cockpit/panels/flightPlan/FlightPlansManagementContext';
import FlightPlanLayer from '@components/map/layers/flightPlans/configuration/FlightPlanLayer';
import ActivationAndFlightPlanInfo from '@components/map/popup/infos/flightplans/ActivationAndFlightPlanInfo';
import MapFeatureSelectionOverlay from '@components/ui/map/MapFeatureSelectionOverlay';
import VisualizationMap from '@components/ui/map/VisualizationMap';
import { useGetConflictingQuery } from '@services/utm/activation.api';
import { FLIGHT_PLAN_LAYERS } from '@utils/map/map.constants';
import { RefObject } from 'react';
import { MapRef } from 'react-map-gl/mapbox';

import { InfoDataTypeEnum } from '@/types/popup.types';

function ActivationAndFlightPlanMixedViewMap() {
  const { selectedActivationAndFlightPlanActivationId, setSelectedActivationAndFlightPlanActivationId } =
    useFlightPlansManagementContext();
  const activationAndFlightPlan = useActivationAndFlightPlanByActivationId(selectedActivationAndFlightPlanActivationId);

  const { data: conflicts } = useGetConflictingQuery(
    { id: selectedActivationAndFlightPlanActivationId ?? 0 },
    { skip: !selectedActivationAndFlightPlanActivationId },
  );

  const handleLoad = (mapRef: RefObject<MapRef | null>) => {
    if (mapRef.current?.getMap()) {
      mapRef.current.loadImage(pattern_conflictZone, (error, image) => {
        if (error) throw error;
        if (!mapRef.current!.hasImage('pattern_conflictZone') && image) {
          mapRef.current!.addImage('pattern_conflictZone', image);
        }
      });
    }
  };

  return (
    <VisualizationMap selectableLayers={FLIGHT_PLAN_LAYERS} handleLoad={handleLoad}>
      {({ mapConstraintsRef }) => (
        <>
          <MapFeatureSelectionOverlay
            layers={FLIGHT_PLAN_LAYERS}
            featureKey="activationId"
            featureLabelKey="name"
            onFeatureSelect={(feature) =>
              setSelectedActivationAndFlightPlanActivationId(feature.properties?.activationId)
            }
            onClearSelection={() => setSelectedActivationAndFlightPlanActivationId(null)}
          />
          <FlightPlanLayer
            selectedActivationAndFlightPlan={activationAndFlightPlan}
            conflictingActivationAndFlightPlans={conflicts}
          />
          {activationAndFlightPlan && (
            <ActivationAndFlightPlanInfo
              mapConstraintsRef={mapConstraintsRef}
              top={2}
              left={2}
              featureValue={activationAndFlightPlan}
              type={InfoDataTypeEnum.INFO_FLIGHT_PLAN}
              onClose={() => setSelectedActivationAndFlightPlanActivationId(null)}
            />
          )}
        </>
      )}
    </VisualizationMap>
  );
}

export default ActivationAndFlightPlanMixedViewMap;
